export default __webpack_public_path__ + "static/media/bash.740b5227.svg";